/**
 * @file app.js
 * @description 应用相关状态管理
 */

export default {
  namespaced: true,
  state: {
    // 是否需要更新用户信息
    userInfoNeedsUpdate: false,
    // 页面加载状态
    loading: true,
    // 加载文本
    loadingText: '页面加载中...'
  },
  mutations: {
    SET_USER_INFO_UPDATE_FLAG(state, value) {
      state.userInfoNeedsUpdate = value
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_LOADING_TEXT(state, text) {
      state.loadingText = text
    }
  },
  actions: {
    setUserInfoNeedsUpdate({ commit }, value) {
      commit('SET_USER_INFO_UPDATE_FLAG', value)
    },
    setLoading({ commit }, value) {
      commit('SET_LOADING', value)
    },
    setLoadingText({ commit }, text) {
      commit('SET_LOADING_TEXT', text)
    }
  }
} 